import { addDays, format } from 'date-fns'
import { nl } from 'date-fns/locale'

const DATE_FORMAT = 'dd-MM-yyyy'
const TIME_FORMAT = 'HH:mm'
const MONTH_DAY_FORMAT = 'd MMMM'
const YEAR_FORMAT = 'yyyy'
const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`

const dutchDateToJSDate = (dutchDate?: string): Date => {
  if (!dutchDate) {
    return new Date()
  }

  const splittedDate = dutchDate.split('-')

  if (splittedDate.length !== 3) {
    return new Date()
  }

  const [day, month, year] = splittedDate.map((item) => parseInt(item, 10))

  return new Date(year, month - 1, day)
}

const yesterday = (formating: string = DATE_FORMAT): string => format(addDays(new Date(), -1), formating)

const formatTimeStamp = (dateString: string, formatting = DATE_FORMAT): string => {
  if (!dateString) {
    return ''
  }

  const date = new Date(dateString)

  return format(date, formatting, { locale: nl })
}

const now = (formatting = DATE_FORMAT) => {
  const date = new Date()

  return format(date, formatting, { locale: nl })
}

const getTillDate = (startDate?: string, endDate?: string): string => {
  if (!startDate && !endDate) {
    return ''
  }

  if (startDate && !endDate) {
    return `Vanaf ${format(new Date(startDate), MONTH_DAY_FORMAT, { locale: nl })} ${format(new Date(startDate), YEAR_FORMAT, { locale: nl })}`
  }

  if (!startDate && endDate) {
    return `t/m ${format(new Date(endDate), MONTH_DAY_FORMAT, { locale: nl })} ${format(new Date(endDate), YEAR_FORMAT, { locale: nl })}`
  }

  if (!startDate || !endDate) { // Just to make TypeScript happy
    return ''
  }

  return `${format(new Date(startDate), MONTH_DAY_FORMAT, { locale: nl })} t/m ${format(new Date(endDate), MONTH_DAY_FORMAT, { locale: nl })} ${format(new Date(endDate), YEAR_FORMAT, { locale: nl })}`
}

const getEndOfDay = (date: Date): Date => {
  const endOfDay = new Date(date)

  endOfDay.setHours(23, 59, 59, 999)

  return endOfDay
}

export default {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  TIME_FORMAT,
  dutchDateToJSDate,
  formatTimeStamp,
  now,
  yesterday,
  getTillDate,
  getEndOfDay
}
